export default __webpack_public_path__ + "static/O0001-492a1588805876536375adc99c20888d.png";